module.exports = __webpack_public_path__ + "media/images/doctor-d9add7ecc98ba9064d84a3e3825af6ea.png";